import React, { Component } from 'react';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import './final.css';
import okCircle from '../../resources/images/ok-circle.svg';
import { connect } from "react-redux";
import config from "../../config/config";
import TitleComponent from '../../components/title/TitleComponent';
import MainButton from '../../components/buttons/main_button/MainButton';
import InfoBoxes from '../../components/info_boxes/InfoBoxes';

const RETAIL_COMPANY_ID = parseInt(config.retail_company_id);
const AF_PUBLIC_URL = config.af_public_url;

class Final extends Component {

    constructor(props) {
        super(props);
        this.redirectToAfPublic = this.redirectToAfPublic.bind(this);
        this.state = {
            redirectCountdownSeconds: null,
        };
        this.redirectTimerId = null;
    }

    isSafeHttpsRedirectUrl(url) {
        if (typeof url !== 'string' || !url.trim()) {
            return false;
        }
        try {
            return new URL(url.trim()).protocol === 'https:';
        } catch (e) {
            return false;
        }
    }

    componentDidMount() {
        const url = this.props.stepInfo?.onFinishRedirectUrl;
        if (!url || !this.isSafeHttpsRedirectUrl(url)) {
            return;
        }

        const total = config.finalRedirectCountdownSeconds;
        if (total <= 0) {
            window.location.assign(url);
            return;
        }

        this.setState({ redirectCountdownSeconds: total });
        this.redirectTimerId = setInterval(() => {
            this.setState((prev) => {
                const next = (prev.redirectCountdownSeconds || 0) - 1;
                if (next <= 0) {
                    if (this.redirectTimerId) {
                        clearInterval(this.redirectTimerId);
                        this.redirectTimerId = null;
                    }
                    window.location.assign(url);
                    return { redirectCountdownSeconds: 0 };
                }
                return { redirectCountdownSeconds: next };
            });
        }, 1000);
    }

    componentWillUnmount() {
        if (this.redirectTimerId) {
            clearInterval(this.redirectTimerId);
            this.redirectTimerId = null;
        }
    }

    redirectToAfPublic = () => {
        const customUrl = this.props.stepInfo.externData;
        return window.location.href = `${AF_PUBLIC_URL}${customUrl}`;
    }

    getFinalMessage = () => {
        let showButton = false;
        if (this.props.stepInfo && this.props.stepInfo.message) {
            return (
                <p className={'description'}>{this.props.stepInfo.message}</p>
            );
        } else {
            if (this.props.source !== 'TRANSFERENCE') {
                const hasFinishRedirect = this.isSafeHttpsRedirectUrl(this.props.stepInfo?.onFinishRedirectUrl);
                return (
                    <>
                        <p className={'description'}>
                            ¡Has tomado la firma con éxito!
                            {!hasFinishRedirect ? ' Ya puedes cerrar esta ventana.' : ''}
                        </p>
                    </>
                );
            } else {
                if (this.props.stepInfo.company_id && this.props.stepInfo.company_id === RETAIL_COMPANY_ID) {
                    return (
                        <>
                            <p className={'description'}>Has finalizado tu firma y ahora pasa a la etapa de revisión. Luego de esto verás la firma estampada en tu contrato.</p>
                            <strong>Puedes regresar a revisar el estado de tu transferencia</strong>
                            {showButton && <div className={'fullwidth'}>
                                <MainButton
                                    onClick={this.redirectToAfPublic}
                                    text={'Ir a la transferencia'}
                                ></MainButton>
                            </div>}
                        </>
                    );
                }

                return (
                    <div className={'description'}>
                        <ul className={'final-description-list'}>
                            <li>El proceso ahora pasará a una etapa de validación de identidad y seguridad, avanzando a medida que las partes y ejecutivos otorguen sus aprobaciones.</li>
                            <li>Una vez finalizado el ciclo, podrás visualizar el contrato con las firmas estampadas.</li>
                        </ul>
                        <p className={'final-description-close'}>Ya puedes cerrar esta ventana.</p>
                    </div>
                );
            }
        }
    }

    render() {
        let title = 'PROCESO';
        if (this.props.stepInfo.externData && this.props.stepInfo.externData != null) {
            title = `PROCESO #${this.props.stepInfo.externData}`
        }
        return (
            <div className={'final'}>
                <Grid>
                    <Row className={'container-content'}>
                        <Col xs={12} className={'content'}>
                            <Image
                                src={okCircle}
                                className={'ok-circle-image-bullet'}
                            />
                            <TitleComponent bolder black className={'text-center'}>Firma realizada con éxito</TitleComponent>
                            {this.getFinalMessage()}
                            {this.state.redirectCountdownSeconds != null && this.state.redirectCountdownSeconds > 0 ? (
                                <p className={'description final-redirect-countdown'}>
                                    Serás redirigido en {this.state.redirectCountdownSeconds}{' '}
                                    {this.state.redirectCountdownSeconds === 1 ? 'segundo' : 'segundos'}.
                                </p>
                            ) : null}
                        </Col>
                    </Row>
                
                    <InfoBoxes step="final" identityType={this.props.stepInfo?.identityType || ''} />
                </Grid>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        code: state.code,
        stepInfo: state.stepInfo,
        stepData: state.stepData,
        source: state.source,
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Final);
